﻿$.fn.dxCtrlEnteteTitleApp = function custom_dxCtrlEnteteTitleApp(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlentetetitleapp dx-ctrl");
        this.createInstance(new cdxCtrlEnteteTitleApp(this, option));
    }
    return this;
}

window.cdxCtrlEnteteTitleApp = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
            dx.option(name, value);
        }
    }

    var $DivContainer = null
    function mConstruit() {
        container.empty();
        container.css({
            "width": "100%",
            "text-align": "center"
        })

        if (typeof option.codeAppli != 'undefined') {
            var baseAppli = parametre.lst_appli_all.filter(function (o) { return o.code_appli == option.codeAppli })[0]
            if (typeof option.showUrlAppli == 'undefined' || option.showUrlAppli) $("<a href='" + baseAppli.urlvitrine + "' style='font-size:120%;position:absolute;bottom:10px;left:10px;' target='_blank'>" + baseAppli.urlvitrine + "</a>").appendTo(container)

            var $Img = $("<img src='" + baseAppli.img_logo + "' style='width:70px;display:inline-block'/>").appendTo(container)

            $("<div style='font-size:400%;text-align:center;color: white;text-shadow: 1px 1px 2px black, 0 0 2px " + theme.backgroundcolorAccent + ", 0 0 5px " + theme.backgroundcolorAccent + ";font-family:bangers;'>" + baseAppli.nom + "</div>").appendTo(container)
        } else {
            if (typeof option.showUrlAppli == 'undefined' || option.showUrlAppli) $("<a href='" + parametre.url_site_vitrine + "' style='font-size:120%;position:absolute;bottom:10px;left:10px;' target='_blank'>" + parametre.url_site_vitrine + "</a>").appendTo(container)

            var $A = $("<a href='" + parametre.url_site_vitrine + "' target='_blank' style='text-decoration:none'/>").appendTo(container)
            var $Img = $("<img src='" + parametre.img + "' style='width:70px;display:inline-block'/>").appendTo($A)

            $("<div style='font-size:400%;text-align:center;color: white;text-shadow: 1px 1px 2px black, 0 0 2px " + theme.backgroundcolorAccent + ", 0 0 5px " + theme.backgroundcolorAccent + ";font-family:bangers;'>" + parametre.nom + "</div>").appendTo($A)
        }


    }

    this.element = function () { return container; }
    this.component = function () { return dx; }

    mConstruit();
}